import { Component, Input, OnInit } from '@angular/core';
import { EllipsisPipe } from '@shared/pipes/ellipsis.pipe';
import { MbIconTextModule, MbIconModule } from '@am/moebius';


@Component({
    selector: 'am-room-header',
    templateUrl: './room-header.component.html',
    styleUrls: ['./room-header.component.scss'],
    standalone: true,
    imports: [
        MbIconTextModule,
        MbIconModule,
        EllipsisPipe,
    ],
})
export class RoomHeaderComponent implements OnInit {
  @Input()
  public roomName: string;

  @Input()
  public adults = 0;

  @Input()
  public children = 0;

  @Input()
  public beds = 0;

  @Input()
  public bathrooms = 0;

  constructor() {}

  ngOnInit(): void {}
}
